<template>
  <div class="min-h-screen">
    <SegmentHero
      title="Política de Privacidade"
      description="LGPD e boas práticas: veja como tratamos seus dados."
      title-class="text-white drop-shadow-md"
      primary-label=""
      primary-href=""
      secondary-label=""
      secondary-href=""
      disclaimer=""
      :background-image="heroBg"
      background-class="bg-center bg-cover bg-slate-900"
      overlay-variant="left"
    />

    <!-- Conteúdo -->
    <div class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-3xl mx-auto">
          <p class="text-sm text-gray-400 mb-6">
            Última atualização: Julho de 2026 · Kali Sistemas · CNPJ 55.252.075/0001-51
          </p>

          <section class="space-y-12">
            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Definições
              </h2>
              <ul class="mt-3 list-disc pl-5 text-gray-600 space-y-2">
                <li>
                  <span class="font-semibold">Dado pessoal:</span> informação
                  relacionada a pessoa natural identificada ou identificável.
                </li>
                <li>
                  <span class="font-semibold">Titular:</span> pessoa natural a
                  quem se referem os dados pessoais.
                </li>
                <li>
                  <span class="font-semibold">Tratamento:</span> operações como
                  coleta, produção, recepção, classificação, utilização, acesso,
                  transmissão, armazenamento e eliminação.
                </li>
                <li>
                  <span class="font-semibold">Controlador:</span> quem toma
                  decisões sobre o tratamento.
                </li>
                <li>
                  <span class="font-semibold">Operador:</span> quem realiza o
                  tratamento em nome do controlador.
                </li>
                <li>
                  <span class="font-semibold">Encarregado (DPO):</span>
                  responsável pela comunicação com titulares e ANPD.
                </li>
              </ul>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Finalidades do Tratamento
              </h2>
              <p class="mt-3 text-gray-600">Tratamos dados pessoais para:</p>
              <ul class="mt-3 list-disc pl-5 text-gray-600 space-y-2">
                <li>Implantar sistemas e soluções adquiridas pelo cliente.</li>
                <li>Atender chamados de suporte e relacionamento.</li>
                <li>
                  Executar testes técnicos e operacionais em bases de dados.
                </li>
              </ul>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Coleta de Dados
              </h2>
              <p class="mt-3 text-gray-600">
                Coletamos dados pessoais apenas quando necessário para fornecer
                nossos serviços, com transparência sobre a finalidade e mediante
                consentimento quando aplicável.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Dados Sensíveis
              </h2>
              <p class="mt-3 text-gray-600">
                O Kali Sistemas não coleta dados pessoais sensíveis conforme a
                definição do Art. 5º, II da LGPD — dados sobre origem racial ou
                étnica, convicção religiosa, opinião política, filiação a
                sindicato ou a organização de caráter religioso, filosófico ou
                político, dados referentes à saúde ou à vida sexual, dado
                genético ou biométrico.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Base Legal
              </h2>
              <p class="mt-3 text-gray-600">
                O tratamento se fundamenta em execução de contrato, cumprimento
                de obrigação legal, exercício regular de direitos, legítimo
                interesse ou consentimento do titular, conforme o caso.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Armazenamento e Retenção
              </h2>
              <p class="mt-3 text-gray-600">
                Os dados pessoais tratados em nome de clientes podem ser
                armazenados por prazo limitado e razoável para a respectiva
                finalidade. Após o período, são excluídos de forma segura. O
                armazenamento definitivo de bases de dados dos clientes é de
                responsabilidade do próprio cliente (servidor local ou nuvem
                contratada).
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Segurança da Informação
              </h2>
              <p class="mt-3 text-gray-600">
                Adotamos medidas técnicas e administrativas para proteger os
                dados contra acesso não autorizado, perda, alteração ou
                divulgação indevida, observando boas práticas de segurança.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Compartilhamento
              </h2>
              <p class="mt-3 text-gray-600">
                Não compartilhamos dados pessoais com terceiros, exceto nas
                hipóteses autorizadas por lei, por ordem judicial ou quando
                necessário para execução dos serviços, sempre com garantias de
                segurança e confidencialidade.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Transferência Internacional de Dados
              </h2>
              <p class="mt-3 text-gray-600">
                Alguns fornecedores que utilizamos processam dados fora do
                Brasil, sempre limitados ao mínimo necessário para a
                finalidade de cada serviço:
              </p>
              <ul class="mt-3 list-disc pl-5 text-gray-600 space-y-2">
                <li>
                  <span class="font-semibold">Google Analytics/Tag Manager</span>
                  (EUA) — analytics do site, apenas se você aceitar cookies no
                  banner.
                </li>
                <li>
                  <span class="font-semibold">Meta (Facebook/Instagram)</span>
                  (EUA) — remarketing e campanhas, quando aplicável.
                </li>
                <li>
                  <span class="font-semibold">Sentry</span> (EUA) —
                  monitoramento técnico de erros do sistema.
                </li>
              </ul>
              <p class="mt-3 text-gray-600">
                Essas transferências se baseiam em cláusulas contratuais
                padrão e nas garantias adotadas por cada fornecedor,
                observando o art. 33 da LGPD.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Direitos do Titular
              </h2>
              <p class="mt-3 text-gray-600">
                Nos termos da LGPD, você pode solicitar: confirmação de
                tratamento, acesso, correção, anonimização, portabilidade,
                eliminação de dados tratados com consentimento, informação sobre
                compartilhamentos e revogação do consentimento. Respondemos em
                até 15 dias.
              </p>
              <p class="mt-3 text-gray-600">
                Para exercer qualquer um desses direitos, use nosso
                <RouterLink
                  to="/meus-dados"
                  class="text-[#006086] font-semibold hover:underline"
                  >formulário de solicitação</RouterLink
                >
                ou envie um e-mail para o encarregado (seção abaixo).
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Menores de Idade
              </h2>
              <p class="mt-3 text-gray-600">
                Nossos serviços são direcionados a pessoas jurídicas e a
                pessoas físicas maiores de 18 anos. Não coletamos
                intencionalmente dados de crianças ou adolescentes. Se você é
                pai, mãe ou responsável e identificar que um menor nos
                forneceu dados pessoais sem o devido consentimento, entre em
                contato com o encarregado (seção abaixo) para que os dados
                sejam removidos.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Cookies e Tecnologias Semelhantes
              </h2>
              <p class="mt-3 text-gray-600">
                Utilizamos cookies para melhorar sua experiência de navegação.
                Você pode ajustar preferências no navegador para bloquear ou
                remover cookies. Algumas funcionalidades do site podem ser
                impactadas.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Links Externos
              </h2>
              <p class="mt-3 text-gray-600">
                Nosso site pode conter links para sites de terceiros. Não nos
                responsabilizamos pelas políticas de privacidade desses sites.
                Recomendamos a leitura das respectivas políticas ao acessá-los.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Contato do Encarregado (DPO)
              </h2>
              <p class="mt-3 text-gray-600">
                Dúvidas ou solicitações relacionadas a dados pessoais: escreva
                para
                <a
                  href="mailto:privacidade@kalisistemas.com.br"
                  class="text-[#006086] font-semibold hover:underline"
                  >privacidade@kalisistemas.com.br</a
                >
                ou faça sua solicitação diretamente pelo
                <RouterLink
                  to="/meus-dados"
                  class="text-[#006086] font-semibold hover:underline"
                  >Meus Dados</RouterLink
                >.
              </p>
            </div>

            <div>
              <h2
                class="text-3xl sm:text-4xl font-extrabold text-[#004d6b] mb-6"
              >
                Aceite e Atualizações
              </h2>
              <p class="mt-3 text-gray-600">
                O uso contínuo do site será considerado como concordância com
                esta política. Ela pode ser atualizada para refletir mudanças
                legais ou operacionais. A versão vigente será sempre publicada
                nesta página.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>

    <CTA />
  </div>
</template>

<script setup>
import CTA from "@/components/home/CTA.vue";
import SegmentHero from "@/components/ui/SegmentHero.vue";
import heroBg from "@/assets/privacy-bg.webp";
import { useSeo } from "@/composables/useSeo";

useSeo({
  title: "Política de Privacidade | Kali Sistemas",
  description: "LGPD e boas práticas: veja como tratamos seus dados.",
  image: heroBg,
});
</script>
